/**
 * Синтаксический сахар. Функция, которая просто выполняет переданный колбэк.
 */

export function doIt<T>(callback: () => T) {
  return callback();
}
